import { getAgentUrl } from '@common/helpers/url';
import { Agent } from '@sly/core/types';
import Helmet from 'next/head';
import { host } from 'sly/config';

export default function AgentProfilePageHeader({ agent }: { agent: Agent }) {
  const { info, name } = agent;
  const { displayName, citiesServed } = info;
  const firstName = displayName.split(' ')[0];
  const firstThreeCities = citiesServed.slice(3).join(', ');
  const title = `${info.displayName} Senior Living Advisor | Seniorly Partner Agents`;
  const description = `Talk to trusted senior living advisor ${info.displayName}. ${firstName} helps families find senior housing in ${firstThreeCities}& more locations!`;
  let noindex = false;
  if (name && name.includes('CarePatrol')) {
    noindex = true;
  }
  const url = getAgentUrl(agent);

  const canonicalUrl = agent?.info?.isPro
    ? `${host}/premier-advisor/${agent.id}`
    : `${host}${url}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      {noindex && <meta name='robots' content='noindex' />}
      <link rel='canonical' href={canonicalUrl} />
    </Helmet>
  );
}
